import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        ingestDataSourceFile: builder.mutation<
            IngestDataSourceFileResponse,
            IngestDataSourceFileRequest
        >({
            query: (request: IngestDataSourceFileRequest) => ({
                url: "ingestDataSourceFile",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useIngestDataSourceFileMutation } = extendedApi;

export interface IngestDataSourceFileRequest {
    country: string;
    dataSourceType: string;
    dataS3Key: string[];
    fileType: string;
    businessUseCase: string;
    content: {
        dataType?: string;
        eventId?: string;
        itemTimeStamp?: string;
    };
}

export interface IngestDataSourceFileResponse {
    executionIds: string[];
    status?: string;
    message?: string;
}
